import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

export const PageTitle = ({ title }) => <h3 className="PageTitle">{title}</h3>

PageTitle.displayName = 'PageTitle'

PageTitle.defaultProps = {
  title: ''
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired
}
